@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.health {
  &Item {
    &Content {
      display: flex;
      align-items: center;

      &Status {
        border-radius: 50%;
        width: 10px;
        height: 10px;
        margin: 0 6px;

        &Success {
          background-color: map.get(core.$colors, success);
        }

        &Info {
          background-color: map.get(core.$colors, accent);
        }

        &Error {
          background-color: map.get(core.$fonts, error);
        }
      }
    }
  }
}
